import { Callout, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import { mefDate } from "../../../../utils/mef";
import Sensor from "./Sensor";

function CameraModel(model) {
  let img;
  switch (model) {
    case "DAHUA":
      img = "/ow/view/pictures/cameras/ITC416_2.webp";
      break;
    case "MILESIGHT":
      img = "/ow/view/pictures/cameras/milesight.webp";
      break;
    case "AXIS":
      img = "/ow/view/pictures/cameras/P3265-LVE.webp";
      break;
    case "SURVISION":
      img = "/ow/view/pictures/cameras/ITC416_1.webp";
      break;
    default:
      return null;
  }

  return <img src={img} alt={model} style={{ maxWidth: 80, maxHeight: 80 }} />;
}

function CameraDetection(s) {
  if (s.detections)
    return (
      <span>
        <Tag>
          {s.detections} <Trans>detections</Trans>
        </Tag>
      </span>
    );
  else return null;
}

export function SensorPreview(props) {
  return (
    <Callout
      title={props.uid}
      onClick={() => {
        if (props.onClick !== undefined)
        props.onClick(props);
      }}
      style={
        props.onClick !== undefined
          ? { cursor: "pointer" }
          : { cursor: "normal" }
      }
      intent={props.selected ? "success" : "normal"}
    >
      <div className="flexbox-left">
        {CameraModel(props?.model)}
        <div>
          <div>
            <Trans>installation date</Trans>
            <Trans>:</Trans>
            {mefDate(props.insert_date)}
          </div>
          {CameraDetection(props)}
        </div>
      </div>
    </Callout>
  );
}

export default function Sensors(props) {
  const [sensors, setSensors] = useState([]);
  const [direct, setDirect] = useState(undefined);

  useEffect(() => {
    authenticatedGetFetch("/ow/dc/sensors?srv=" + props.srv, (sensors) => setSensors(sensors));
    authenticatedGetFetch("/ow/dc/sensors/perf?srv=" + props.srv, (sensors) =>
      setSensors(sensors)
    );
  }, [props.srv]);

  return (
    <Callout icon="camera" title={<Trans>sensors</Trans>}>
      <div className="flexbox-left">
        {sensors.map((s) => (
          <span key={s.uid}>
            <SensorPreview
              {...s}
              selected={direct?.id === s.id}
              onClick={() => setDirect(s)}
            />
            <br />
          </span>
        ))}
      </div>
      <div>
        <Sensor {...direct} srv={props.srv}/>
      </div>
    </Callout>
  );
}
